var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82051 17.3278C5.30385 17.1924 4.46923 16.6471 4.0241 15.5658C3.86346 15.1762 3.75128 14.7212 3.67949 14.1842C3.67949 14.0921 3.58974 14 3.5 14C3.41026 14 3.32051 14.0921 3.32051 14.1842C3.24872 14.7212 3.13654 15.1762 2.9759 15.5658C2.53167 16.6471 1.69705 17.1924 0.179487 17.3278C0.0897436 17.3278 0 17.4199 0 17.512C0 17.6041 0.0897436 17.6962 0.179487 17.6962C2.0641 18.0646 3.05128 18.7895 3.32051 20.8158C3.32051 20.9079 3.41026 21 3.5 21C3.58974 21 3.67949 20.9079 3.67949 20.8158C3.94872 18.7895 4.9359 18.0646 6.82051 17.6962C6.91026 17.6962 7 17.6041 7 17.512C7 17.4199 6.91026 17.3278 6.82051 17.3278Z",
    fill: "url(#paint0_linear_4929_23635)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3185 9.33334C15.2511 8.26667 13.0645 5.69333 12.051 0.494667C12.0169 0.353994 11.9395 0.229172 11.8309 0.139685C11.7222 0.0501983 11.5885 0.00108072 11.4506 0C11.3116 0.00116312 11.1769 0.0511033 11.0679 0.141911C10.9589 0.232719 10.8818 0.359204 10.8488 0.501334C10.8374 0.509334 10.8577 0.481334 10.8488 0.501334C9.83533 5.83467 7.52334 8.26667 2.58264 9.33334C2.41465 9.33334 2.25353 9.40357 2.13474 9.5286C2.01595 9.65362 1.94922 9.82319 1.94922 10C1.94922 10.1768 2.01595 10.3464 2.13474 10.4714C2.25353 10.5964 2.41465 10.6667 2.58264 10.6667C7.65002 11.7333 9.8252 14.2493 10.8387 19.4493C10.8626 19.6023 10.9371 19.7415 11.0491 19.8423C11.161 19.943 11.3032 19.9989 11.4506 20C11.5919 19.9987 11.7286 19.9469 11.8384 19.8532C11.9481 19.7594 12.0245 19.6293 12.0548 19.484C12.0485 19.4973 12.0624 19.4733 12.0548 19.484C13.0683 14.1507 15.3778 11.7333 20.3185 10.6667C20.4865 10.6667 20.6476 10.5964 20.7664 10.4714C20.8852 10.3464 20.9519 10.1768 20.9519 10C20.9519 9.82319 20.8852 9.65362 20.7664 9.5286C20.6476 9.40357 20.4865 9.33334 20.3185 9.33334Z",
    fill: "url(#paint1_linear_4929_23635)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2968 3.00061C21.2968 2.89689 21.2215 2.82774 21.1189 2.80798L21.0497 2.79193C19.6066 2.41531 18.7318 1.52747 18.4884 0.188928C18.4884 0.138821 18.4684 0.0907663 18.433 0.0553356C18.3975 0.0199048 18.3495 0 18.2993 0V0.00493951C18.1955 0.00493951 18.1263 0.0814981 18.1066 0.182753L18.0905 0.251903C17.7137 1.69417 16.8253 2.56842 15.4859 2.81168C15.4358 2.81168 15.3877 2.83159 15.3522 2.86702C15.3168 2.90245 15.2969 2.9505 15.2969 3.00061H15.3018C15.3018 3.10434 15.3784 3.17349 15.481 3.19324L15.5489 3.2093C16.9921 3.58592 17.8669 4.47375 18.1103 5.81229C18.1103 5.91602 18.1955 6.00122 18.2993 6.00122V5.99628C18.4031 5.99628 18.4723 5.91972 18.4921 5.81723L18.5094 5.74932C18.885 4.30705 19.7734 3.4328 21.1127 3.18954C21.1374 3.18954 21.1618 3.18463 21.1845 3.17509C21.2072 3.16555 21.2278 3.15158 21.2451 3.13398C21.2624 3.11639 21.2759 3.09553 21.285 3.07263C21.2941 3.04973 21.2973 3.02524 21.2968 3.00061Z",
    fill: "url(#paint2_linear_4929_23635)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4929_23635",
    x1: 8.23737,
    y1: 12.7273,
    x2: -0.389065,
    y2: 13.1551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347AF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4929_23635",
    x1: 24.311,
    y1: -3.63635,
    x2: 0.887447,
    y2: -2.5326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347AF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4929_23635",
    x1: 22.3575,
    y1: -1.09113,
    x2: 14.9634,
    y2: -0.724495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347AF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.e42bae1addc2d110479edfe5cbca3b31.svg";
export { ForwardRef as ReactComponent };